import * as React from "react";
import { Grid, Typography, TextField, Chip, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import DownArrow from "../DownArrow";
import DialplanNode, { useDialplanNodeContext } from "./DialplanNode";
import { useDialplanEditorContext } from "./DialplanEditorContext";
import TtsAnnounce from "./TtsAnnounce";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useLabelsRepository } from "../../repository/LabelsRepository";

const NEW_LABEL_OPTION = "__new__";

function AddLabelNode() {
    const { isEditMode } = useDialplanEditorContext();
    const { node, setNodeChild } = useDialplanNodeContext();
    const { data: labels } = useLabelsRepository();

    const existingLabelNames = (labels || []).map((label) => label.name);
    const isExistingLabel = !!node.label && existingLabelNames.includes(node.label);
    const [mode, setMode] = React.useState(isExistingLabel ? "existing" : NEW_LABEL_OPTION);

    React.useEffect(() => {
        if (isExistingLabel && mode !== "existing") {
            setMode("existing");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isExistingLabel]);

    const handleSelectChange = (e) => {
        const value = e.target.value;
        if (value === NEW_LABEL_OPTION) {
            setMode(NEW_LABEL_OPTION);
            setNodeChild("label")("");
        } else {
            setMode("existing");
            setNodeChild("label")(value);
        }
    };

    return (
        <>
            <Grid container direction={"column"}>
                <Grid item xs={12}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 8
                    }}>
                        <LocalOfferIcon style={{ fontSize: 28, color: '#1976d2' }} />
                        <Typography variant="h6" align="left">
                            Aggiungi etichetta
                        </Typography>
                    </div>
                </Grid>
                
                <Grid item xs={12} sx={{ mt: 2 }} justifyContent="flex-start">
                    <Typography variant="body" display={"inline"}>
                        Assegna un'etichetta alla chiamata per categorizzarla e organizzarla meglio.
                    </Typography>
                </Grid>

                {isEditMode && (
                    <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="add-label-node-select-label">Etichetta</InputLabel>
                                <Select
                                    labelId="add-label-node-select-label"
                                    label="Etichetta"
                                    value={mode === "existing" ? (node.label || "") : NEW_LABEL_OPTION}
                                    onChange={handleSelectChange}
                                >
                                    {existingLabelNames.map((name) => (
                                        <MenuItem key={name} value={name}>{name}</MenuItem>
                                    ))}
                                    <MenuItem value={NEW_LABEL_OPTION}>+ Nuova etichetta</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {mode === NEW_LABEL_OPTION && (
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <TextField
                                    fullWidth
                                    label="Nome nuova etichetta"
                                    value={node.label || ""}
                                    onChange={(e) => setNodeChild("label")(e.target.value)}
                                    placeholder="es. Urgente, VIP, Supporto..."
                                    inputProps={{ maxLength: 20 }}
                                    helperText={`${(node.label || "").length}/20 caratteri`}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        )}
                    </>
                )}

                {!isEditMode && node.label && (
                    <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                        <Chip
                            icon={<LocalOfferIcon />}
                            label={node.label}
                            color="primary"
                            size="medium"
                            sx={{ 
                                fontSize: '1rem',
                                py: 2.5,
                                px: 1
                            }}
                        />
                    </Grid>
                )}
            </Grid>
            <DownArrow/>
            <DialplanNode prop="next"/>
        </>
    );
}

AddLabelNode.title = "Aggiungi etichetta";
AddLabelNode.description = "Aggiunge un'etichetta alla chiamata per categorizzarla e organizzarla";
AddLabelNode.default = {
    type: "ADD_LABEL",
    label: "Importante",
    next: TtsAnnounce.default
};
AddLabelNode.isAdvanced = false;

export default AddLabelNode;